/**
 * SSR- and private-mode-safe accessors for the Web Storage APIs.
 *
 * `window.localStorage` / `window.sessionStorage` can throw (or be absent) when
 * running outside a browser (SSR), in some sandboxed iframes, or when storage is
 * disabled (Safari private mode, enterprise lockdown, etc.). These helpers
 * return `null` instead of throwing so callers can degrade gracefully.
 */

export function safeGetLocalStorage(): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.localStorage;
  } catch {
    return null;
  }
}

export function safeGetSessionStorage(): Storage | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}
